import React from 'react';
import FuseTheme from './theme';
import TokenCheck from '../components/TokenCheck';
import Config from '../messages';

const styles = {
    footerContainer: {
        // display: 'flex',
        // flex: '1 1 100%',
        // boxSizing: 'border-box',
    },
    footer: {
        backgroundColor: FuseTheme.palette.lightCanvasColor,
        width: '100%',
        fontFamily: 'Roboto, sans-serif',
        fontSize: 14,
        color: FuseTheme.palette.primary3Color,
        textAlign: 'center',
        margin: '0 auto',
        padding: '1em 2em',
        boxSizing: 'border-box',
    },
    p: {
        flex: '1 1 0%',
        margin: 0
    },
};

/**
 * Get display mode
 */
const displayAppMode = () => {
    const mode = process.env.NODE_ENV;
    return (mode && mode !== 'production') ? ' (' + mode + ' build)' : '';
};


const copyright = new Date().getFullYear();

export const FuseFooter = () => (
    <div style={styles.footerContainer} className="footer-container">
        <div key="Footer" style={styles.footer} className="footer">
            <p style={styles.p}>
            <span className="footer-block">
                CloudSent POS Operator Portal {Config.fuse.admin.version}{displayAppMode()}
            </span>
                <span className="footer-divider">|</span>
                <span className="footer-block">
                &copy; {copyright} {Config.fuse.copyright.owner}. {Config.fuse.copyright.legalText}
            </span>
            </p>
        </div>
        <TokenCheck key="AppTokenCheck" name="AppTokenCheck" token={null}/>
    </div>
);



// WEBPACK FOOTER //
// ./src/Fuse/global/footer.js